var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.473,
    height: 39.315,
    viewBox: "0 0 43.473 39.315",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(-1 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14639",
    "data-name": "Path 14639",
    d: "M28.95,25.8a2.073,2.073,0,0,0-2.073,2.073V34.1A2.073,2.073,0,0,1,24.8,36.169H8.219A2.073,2.073,0,0,1,6.146,34.1V9.219A2.073,2.073,0,0,1,8.219,7.146H24.8a2.073,2.073,0,0,1,2.073,2.073v6.219a2.073,2.073,0,1,0,4.146,0V9.219A6.219,6.219,0,0,0,24.8,3H8.219A6.219,6.219,0,0,0,2,9.219V34.1a6.219,6.219,0,0,0,6.219,6.219H24.8A6.219,6.219,0,0,0,31.023,34.1V27.877A2.073,2.073,0,0,0,28.95,25.8Z",
    transform: "translate(0 0)",
    fill: "#c32bd6",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14640",
    "data-name": "Path 14640",
    d: "M38.031,14.825,31.812,8.606a2.082,2.082,0,0,0-2.944,2.944l2.695,2.674H8.573a2.073,2.073,0,0,0,0,4.146h22.99l-2.695,2.674a2.082,2.082,0,1,0,2.944,2.944l6.219-6.219a2.073,2.073,0,0,0,0-2.944Z",
    transform: "translate(4.829 5.361)",
    fill: "#c32bd6",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.737c521dcad2863ab87021aa388b76c8.svg";
export { ForwardRef as ReactComponent };